import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { approveOrderReq, getDetailsByStatus, getOrderDetails, getOrderInfoReq, getVendorOrders, rejectOrderReq, saveAwbObj, saveOrderInfoReq } from "../../../../modules/VendorModule/Services/VendorApprovalService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";

export const defQtyPropName = "quantity";

const detailsMapper = (order, qtyPropName) => {
    if (order.abreviation === "EA") {
        let result = Array.from({ length: order[qtyPropName] }).map((_, j) => ({ ...order, qtyab: "1 EA", tempId: crypto.randomUUID() }));
        return result;
    } else {
        let result = [{ ...order, qtyab: `${order[qtyPropName] } ${order.abreviation}` }];
        return result;
    }
    (order.abreviation === "EA" ? Array.from({ length: order.quantity }).map((_, j) => ({ ...order, qtyab: "1 EA", tempId: crypto.randomUUID() })) : [{ ...order, qtyab: `${order.quantity} ${order.abreviation}` }])
}

const VendorAwbSlice = createSlice({
    name: "vendorAwb",
    initialState: {

        orderItems: [],
        editing: {},
        itemsSelection: {},
        idsSelection: {},
        sendInfo: {},
        search: "",
        orderBy: "",
        page: 0,
        loading: false,
        totalPages: 1,
        openStatus: {}
    },
    reducers: {
        updateOrderItem: (state, action) => {
            let { idx, name, value } = action.payload;
            let copy = [...state.orderItems];
            copy[idx] = { ...copy[idx], [name]: value };
            return { ...state, orderItems: copy };
        },
        toggleSelect: (state, action) => {
            let { tempId, v, itemId } = action.payload;
            return { ...state, editing: { ...state.editing, [tempId]: v ? true : (state.editing[tempId] ?? false) }, itemsSelection: { ...state.itemsSelection, [tempId]: v }, idsSelection: { ...state.idsSelection, [itemId]: v } }
        },
        updateSendInfo: (state, action) => {
            let { tempId, name, value } = action.payload;
            // return {...state}
            return { ...state, sendInfo: { ...state.sendInfo, [tempId]: { ...(state.sendInfo[tempId] ?? {}), [name]: value } } }
        },
        updateSearch: (state, action) => {
            let { search } = action.payload;
            return { ...state, search, page: 0 };
        },
        updateOrderBy: (state, action) => {
            let { orderBy } = action.payload;
            return { ...state, orderBy, page: 0 };
        },
        nextPage: (state, action) => {
            return { ...state, page: state.page + 1 };
        },
        toggleEdit: (state, action) => {
            let { tempId, value } = action.payload;
            return { ...state, editing: { ...state.editing, [tempId]: value } }
        },
        toggleOpen: (state, action) => {
            let { tempId, value } = action.payload;
            return { ...state, openStatus: { ...state.openStatus, [tempId]: value } }
            F
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchDetails.pending, (state, action) => {
            return { ...state, loading: true }
        });


        builder.addCase(fetchDetails.rejected, (state, action) => {
            return { ...state, loading: false };
        })
        builder.addCase(getOrderInfo.fulfilled, (state, action) => {
            let { tempId, orderInfo } = action.payload;
            return { ...state, sendInfo: { ...state.sendInfo, [tempId]: orderInfo } };
        })
        builder.addCase(fetchDetails.fulfilled, (state, action) => {
            let { details, totalPages } = action.payload;
            let mappedDetails = details.map(o => ({ ...o, tempId: crypto.randomUUID(), category: o.abreviation === "EA" ? "Serialized" : "Consumable", awb_number: o.awb_number })).flatMap((z)=>detailsMapper(z, defQtyPropName));
            let reducedDetails = mappedDetails.reduce((acc, curr) => ({
                ...acc, [curr.tempId]: { serialNumber: "", vendorLot: "", quantity: curr.category === "Serialized" ? 1 : "", id: null, tempId: curr.tempId, vendorOrderDetailId: curr.id, partCategory: curr.category }
            }), {});
            return {
                ...state,
                orderItems: state.page > 0 ? [...state.orderItems, ...mappedDetails] : mappedDetails,
                loading: false,
                totalPages,
                // page: details.length === 0 ? Math.max(state.page - 1, 0) : state.page,
                sendInfo: state.page > 0 ? { ...state.sendInfo, ...reducedDetails } : reducedDetails
            };
        });
        builder.addCase(createAWB.fulfilled, (state, action) => {
            let { awb, ordersSendInfo, qtyPropName } = action.payload;
            let newSendInfo = {};
            let copy = [...state.orderItems.flatMap(order => {
                let info = ordersSendInfo.find(info => info.tempId === order.tempId);
                // let orderIdx = state.orderItems.findIndex(order => order.tempId === info.tempId);
                // let ordersCopy = [...state.orderItems];
                // if (orderIdx > 0) {
                //     ordersCopy[orderIdx] = {...ordersCopy[orderIdx], anvoId: info.id}
                // }
                if (info) {
                    if (info.partCategory === "Serialized") {
                        newSendInfo = { ...newSendInfo, [info.tempId]: info };
                        return { ...order, status: "Shipped", awb_number: awb, anvoId: info.id }
                    } else {
                        if (order[qtyPropName] > info.quantity) {
                            let newTempId = crypto.randomUUID();
                            newSendInfo = { ...newSendInfo, [newTempId]: { serialNumber: "", vendorLot: "", quantity: "", id: null, tempId: newTempId, vendorOrderDetailId: order.id, partCategory: order.category } }
                            return [
                                { ...order, anvoId:info.id, status: "Shipped", awb_number: awb, [qtyPropName]: info.quantity, qtyab: `${info.quantity} ${order.abreviation}` },
                                { ...order, status: "Partially Shipped", awb_number: "", [qtyPropName]: order[qtyPropName] - info.quantity, qtyab: `${order[qtyPropName] - info.quantity} ${order.abreviation}`, tempId: newTempId }
                            ]
                        } else {
                            newSendInfo = { ...newSendInfo, [info.tempId]: info };
                            return { ...order, anvoId:info.id, status: "Shipped", awb_number: awb }
                        }
                    }
                } else {
                    return order;
                }
            })];
            return { ...state, orderItems: copy, itemsSelection: {}, idsSelection: {}, sendInfo: { ...state.sendInfo, ...newSendInfo } };
        });
        builder.addCase(saveOrderInfo.fulfilled, (state, action) => {
            let { orderInfo, tempId } = action.payload;
            return { ...state, sendInfo: { ...state.sendInfo, [tempId]: orderInfo } };
        })

    }
});

export const fetchDetails = createAsyncThunk("vendorAwb/fetchOrderDetails",
    async ({ companyId, search, page, orderBy }, { getState, rejectWithValue }) => {

        let response = await getDetailsByStatus(["Vendor Approved", "Partially Shipped", "Shipped", "shipped"], search, page, orderBy);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { details: response.data.load, totalPages: response.data.totalPages }
        } else {
            return rejectWithValue(null);
        }
    }
)

export const createAWB = createAsyncThunk("vendorAwb/createAWB",
    async ({ awb, orderDetailObjs, ordersSendInfo, shipViaVendorId, shipViaAccountId, shipViaRemarks }, { getState, rejectWithValue }) => {
        // let responses;

        let responsesInfo = await Promise.all(
            ordersSendInfo.map(
                orderSendInfo => saveOrderInfoReq({ ...orderSendInfo }).then(response => ({ ...response, data: { ...response.data, load: { ...response.data.load, partCategory: orderSendInfo.partCategory, tempId: orderSendInfo.tempId } } }))
            ));
        if (responsesInfo.every(responseInfo => responseInfo.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS)) {
            let responseAwb = await saveAwbObj({ id: null, awbStatus: "Shipped", awbNumber: awb, orderDetails: orderDetailObjs.map(dObj => typeof(dObj.awbVendorOrderId) === 'number' ? dObj: {...dObj, awbVendorOrderId:responsesInfo.find(r => r.data.load.tempId === dObj.tempId)?.data?.load?.id ?? dObj}), shipViaVendorId, shipViaAccountId, shipViaRemarks });
            if (responseAwb.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                return { ordersSendInfo: responsesInfo.map(r => r.data.load), awb: responseAwb.data.load.awbNumber, qtyPropName:defQtyPropName };
            } else {
                return rejectWithValue(null);
            }
        } else {
            return rejectWithValue(null);
        }




    }
)

export const saveOrderInfo = createAsyncThunk("vendorAwb/saveOrderInfo",
    async ({ orderInfo, tempId }, { getState, rejectWithValue }) => {
        let response = await saveOrderInfoReq(orderInfo);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return {
                orderInfo: response.data.load, tempId
            }
        } else {
            return rejectWithValue(null);
        }

    }
)

export const getOrderInfo = createAsyncThunk("vendorAwb/getOrderInfo",
    async ({ tempId, anvoId }, { getState, rejectWithValue }) => {
        let response = await getOrderInfoReq(anvoId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return {
                orderInfo: {...response.data.load, tempId}, tempId
            }
        } else {
            return rejectWithValue(null);
        }

    }
)

export const { updateOrderItem, toggleSelect, updateSendInfo, updateSearch, nextPage, toggleEdit, toggleOpen, updateOrderBy } = VendorAwbSlice.actions;
export const selectOrderItems = (state) => state.vendorAwb.orderItems;
export const selectSendInfo = (state) => state.vendorAwb.sendInfo;
export const selectItemsSelection = (state) => state.vendorAwb.itemsSelection;
export const selectIdsSelection = (state) => state.vendorAwb.idsSelection;
export const selectSearchAwb = (state) => state.vendorAwb.search;
export const selectOrderByAwb = (state) => state.vendorAwb.orderBy;
export const selectAwbLoading = (state) => state.vendorAwb.loading;
export const selectAwbPage = (state) => state.vendorAwb.page;
export const selectAwbTotalPages = (state) => state.vendorAwb.totalPages;
export const selectAwbEditing = (state) => state.vendorAwb.editing;
export const selectAwbOpenStatus = (state) => state.vendorAwb.openStatus;
export default VendorAwbSlice.reducer;